export default __webpack_public_path__ + "static/media/ART14.8e396bb0.jpg";